import React, { useState, useEffect } from "react";
import styled from "styled-components"

import { ERC20 } from "../abi/abi";

import CurrencyValue from "./CurrencyValue"
import NumericalValue from "./NumericalValue"



const PanelCurrencyBalanceTitle = styled.div`
	margin: 0, auto;
    font-size: 1.5em;
    text-align: left;
    align-self: center;
    justify-content: left;
`;

const PanelCurrencyBalanceValue = styled(NumericalValue)`
    margin: 0, auto;
    font-size: 1.5em;
    text-align: left;
    align-self: center;
    margin-left: 0.3em;
    justify-content: left;
    color: ${({ enoughBalance }) => enoughBalance != undefined ? enoughBalance ? "#1DDD94" : "#F3729A" : "inherited"};
    font-weight: bold;
`;

const _PanelCurrencyBalance = styled.div`
    background-color: inherited;
    pointer-events: auto;
    font-size: 0.5em;
    margin: 0, auto;
    text-align: right;
    display:flex;
    flex-direction: row;
	justify-content: left;
`;

function PanelCurrencyBalance(props) {

	const [balance, setBalance] = useState()

	useEffect(() => {
		if (props.web3 != undefined) {
			const contract = new props.web3.eth.Contract(ERC20, props.token["address"]);
			if (contract != undefined && props.account != undefined) {
				getERC20Balance(contract, props.account)
			}
		}
	}, [props.web3 != undefined, props.account]);

	async function getERC20Balance(erc20Contract, account) {
		Promise.all([
			erc20Contract.methods
				.balanceOf(account)
				.call({ }),
			erc20Contract.methods
				.decimals()
				.call({ })
		])
		.then(values =>  {
			setBalance(
				props.web3.utils.fromWei(values[0].toString(), "ether") * Math.pow(10, (18-values[1]))
			)
		})
	}
	return (
		<div>
			{
		 		props.account ?
					<div>
						{
							balance != undefined ?
								<_PanelCurrencyBalance>
									<PanelCurrencyBalanceTitle>
										Balance:
									</PanelCurrencyBalanceTitle>
									<PanelCurrencyBalanceValue enoughBalance={props.tokenTargetQuantity ? props.tokenTargetQuantity <= balance : undefined}>
										{balance ? balance.toFixed(3) : 0}
									</PanelCurrencyBalanceValue>
								</_PanelCurrencyBalance>
								: <div>"Loading..."</div>
						}
					</div>
					: <></>
			}
		</div>
	)
}
export default PanelCurrencyBalance;

